import * as React from 'react'
import Drawer from '@mui/material/Drawer';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { mainNavbarItems } from './consts/navbarListItems';
import UnstyledLink from '../common/UnstyledLink/UnstyledLink';

const drawerWidth = 300

const Navbar = () => {
    return (
        <Drawer
            sx={{
                width: drawerWidth,
                flexShrink: 0,
                [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: 'border-box' },
                display: { xs: 'none', sm: 'none', md: 'inline' } 
            }}
            variant="permanent"
        >
            <Toolbar />
            <Divider />
            <List>
                {mainNavbarItems.map((item) => (
                    <UnstyledLink key={item.id} to={item.route}>
                        <ListItem  disablePadding>
                            <ListItemButton>
                                <ListItemIcon>
                                    {item.icon}
                                </ListItemIcon>
                                <ListItemText primary={item.label} />
                            </ListItemButton>
                        </ListItem>
                    </UnstyledLink>
                ))}
            </List>
        </Drawer>
    )
}

export default Navbar